export interface CreateContributionApiModel{
    [key: string]: any
}